import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import LockerMenu from "../../Components/LockerMenu";

import Section1_Header from "../S1_Header";
import Section2_About from "../S2_Aboutus";
import Section3_Tokenomics from "../S5_Tokenomics";
import Section6_Footer from "../Section6_Footer";

import { PageWrapper } from "../../Styles/style";
import { Wrapper } from "./styles";

import up from "../../../assets/images/footerimg.png"
import styled from "@emotion/styled";


const MainPage = (props) => {
  const SectionSubWrapper = styled.div`
  background-image: url(${up});
  background-position: bottom right;
  z-index: 1;
  background-size: contain;
  background-repeat: no-repeat;
  
    `
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>
      <PageWrapper>
        <Wrapper>
          <LockerMenu />
          <Section1_Header />
        </Wrapper>
          <Section2_About />
        <SectionSubWrapper>
          <div style={{minHeight:"calc(100vh - 10px)"}}>
          <Section3_Tokenomics />
          </div>
          <Section6_Footer />
        </SectionSubWrapper>
      </PageWrapper>
    </>
  );
};

export default MainPage;
